import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../Contexts/GlobalContext';


export default function useTawk(props) {
    const globalContext = useContext(GlobalContext);
    const [loadScript, setLoadScript] = useState(false);
 

    useEffect (
        () => {
            if(loadScript){
                console.log(globalContext.globalState.selectedGuiLanguage);
                var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
                (function () {
                    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
                    s1.async = true;
                    if (globalContext.globalState.selectedGuiLanguage == 'tr') {
                        s1.src = 'https://embed.tawk.to/5f71c5a54704467e89f2e0a1/default'; //tr
                    }
                    else {
                        s1.src = 'https://embed.tawk.to/5f9aa7677f0a8e57c2d829f4/default'; //eng
                    }
                    s1.charset = 'UTF-8';
                    s1.setAttribute('crossorigin', '*');
                    s0.parentNode.insertBefore(s1, s0);
                })();
            }
        },[loadScript]
    )

    useEffect(
        () => {
            const f = async () => {
                
                
                await waitForSeconds(3);
                setLoadScript(true);
                
                
                
            }//f()
            f();
        }, []
    )

    const waitForSeconds = async (seconds) => {
        return await new Promise(
            (resolve, reject)=>{
                let ctr = 0;
                let intervalId = setInterval(() => {
                    ctr = ctr +1;
                    console.log(ctr);
                    if(ctr==seconds){
                        clearInterval(intervalId);
                        resolve();
                    }
                }, 1000);
            }
        )
    }

    return null;
}
